import * as React from "react";

function IDCell(props) {
    return (
        <td
            {...props}
            className="align-items-center"
            style={{
                touchAction: "none",
            }}
        >
            <span className="d-flex align-items-center">
                <span
                    className="fas fa-grip-vertical pe-2"
                    style={{
                        cursor: "move",
                        fontSize: "14px"
                    }}
                    data-drag-handle={true}
                />
                &nbsp;
                {
                    props.dataItem['#']
                }
            </span>
        </td>
    );
};

export default IDCell;